import React from 'react'
import './App.css'
import './App.scss'

import auth from './auth/service'

import Footer from './components/Footer'
import HistoricalReport from './containers/HistoricalReportForm/HistoricalReport'
import KeywordIdeas from './containers/KeywordIdeas/KeywordIdeas'
import CreateVolumeRetrieve from './containers/VolumeRetrieve/CreateVolumeRetrieve'
import VolumeRetrieve from './containers/VolumeRetrieve/VolumeRetrieve'
import VolumeRetrieveListing from './containers/VolumeRetrieve/VolumeRetrieveListing'
import VolumeRetrieveForm from './containers/VolumeRetrieve/VolumeRetrieveForm'
import VolumeRetrieveEdit from './containers/VolumeRetrieve/VolumeRetrieveEdit'
import ScheduledStudiokwDetail from './containers/ScheduledStudiokwDetail/ScheduledStudiokwDetail'
import ScheduledStudioKwIndexDetail from './containers/StudiKwIndex/ScheduledStudioKwIndexDetail'
import DuplicateKeywordsGpt from './containers/DuplicateKeywordsGptForm/DuplicateKeywordsGpt'
import KeywordClustering from './containers/KeywordClustering/KeywordClustering'
import BulkIndexing from './containers/BulkIndexing/BulkIndexing'
import SemRush from './containers/SemRush/SemRush'
import HtmlCleaner from './containers/HtmlCleaner/HtmlCleaner'
import { Route, Router, Switch, Redirect } from 'react-router-dom'
import history from './history'
import Home from './main/Home'
import AddStudiokw from './main/AddStudiokw'
import AddScheduling from './main/AddScheduling'
import AddSchedulingIndex from './main/AddSchedulingIndex'
import BigQueryExporter from './main/BigQueryExporter'
import BigQueryExporterFile from './main/BigQueryExporterFile'
import LazyLoad from './main/LazyLoad'
import Scheduling from './main/Scheduling'
import SchedulingIndex from './main/SchedulingIndex'
import { Container } from 'reactstrap'
import CreateReport from './tagging_tool/containers/CreateReport/CreateReport'
import DimensionGroups from './tagging_tool/containers/DimensionGroups/DimensionGroupsAdmin'
import Sidebar from './containers/Sidebar/Sidebar'
import Callback from './components/Callback/Callback'

import Listing from './tagging_tool/containers/Listing/Listing'
import DimensionDetail from './tagging_tool/containers/DetailReport/DimensionDetail'
import SeoReport from './tagging_tool/containers/SeoReport/SeoReport'
import DimensionGroupInfo from "./tagging_tool/containers/DimensionGroups/DimensionGroupInfo/DimensionGroupInfo";

import AlertEvents from './containers/SeoMonitoring/AlertEvents'
import AlertEventsDetail from './containers/SeoMonitoring/AlertEventsDetail'
import SiteUrlManage from './containers/SeoMonitoring/SiteUrlManage'
import SiteUrlList from './containers/SeoMonitoring/SiteUrlList'
import EmailAlertsRead from './containers/SeoMonitoring/EmailAlertsRead'

import { GTM_ID } from './utils/index'
import TagManager from 'react-gtm-module'
import routes from "./links";
import StudiokwEmailAlertsRead from "./main/StudiokwEmailAlertsRead";
import KeywordClusteringFile from "./containers/KeywordClustering/KeywordClusteringFile";
import PED from "./containers/PED/PED"
import PEDFile from "./containers/PED/PEDFile"
import MonitoringDashboard from "./containers/MonitoringDashboard/MonitoringDashboard";
import ContentGen from './containers/ContentGen/ContentGen'
import ContentGenFile from './containers/ContentGen/ContentGenFile'

import KeywordIntentions from './containers/KeywordIntentions/KeywordIntentions'
import AddKeywordIntentions from './containers/KeywordIntentions/AddKeywordIntentions'
import LLMVisibilityForm from "./containers/LLMVisibility/LLMVisibilityForm";
import LLMVisibilityListing from "./containers/LLMVisibility/LLMVisibilityListing";
import CategoryTextGenListing from "./containers/CategoryTextGen/CategoryTextGenListing";
import CategoryTextGenForm from "./containers/CategoryTextGen/CategoryTextGenForm";

const tagManagerArgs = {
  gtmId: GTM_ID,
}

const environment = process.env

if (environment.NODE_ENV === 'production') {
  TagManager.initialize(tagManagerArgs)
}


class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      profile: null,
      userGroup: null,
      allowedServices: null,
    };

    this.handleLogout = this.handleLogout.bind(this)
  }

  handleLogout() {
    auth.logout()
  }

  componentDidMount() {
    if (localStorage.getItem('isLoggedIn') === 'true') {
      auth.renewSession().then(() => {
        if (!auth.userProfile) {
          auth.getProfile().then(() => {
            // After profile and group are loaded, fetch allowed services
            auth.getAllowedServices().then((services) => {
              this.setState({
                profile: auth.userProfile,
                userGroup: auth.userGroup,
                allowedServices: services,
              });
            });
          });
        } else {
          auth.getAllowedServices().then((services) => {
            this.setState({
              profile: auth.userProfile,
              userGroup: auth.userGroup,
              allowedServices: services,
            });
          });
        }
      });
    }
  }

  render() {

    const { userGroup, allowedServices } = this.state;

    if (allowedServices === null) {
      return <Callback />
    }

    // Determine if the user is allowed to access the "/" route.
    const canAccessHome =
      userGroup === 'Webranking' ||
      (allowedServices && allowedServices.some(service => service.route === '/'));

    // Determine a default allowed route if "/" is not accessible.
    const defaultRoute =
      allowedServices.length > 0 ? allowedServices[0].route : "/not-authorized";

    return (
      <div className='main' id="main">
        <Sidebar
            isAuthenticated={false}
            userGroup={this.state.userGroup}
            allowedServices={this.state.allowedServices}  // Pass allowed services here
            onLogout={this.handleLogout}
            routes={routes}
            logo={{
              innerLink: "/",
              imgSrc: require("./assets/img/brand/cropped-logo.png"),
              imgAlt: "..."
            }}
            id="sidebar"
        />
        <div className="main-content" id="main-content">
          <Router history={history}>
            <Container fluid>
              <Switch>
                {/*<Route path={'/historical-retrieve'} component={HistoricalReport} />*/}
                <Route path={'/keyword-ideas'} component={KeywordIdeas} />
                <Route path={'/scheduling'} component={Scheduling} />
                <Route path={'/scheduled_studiokw_list/:id?'} component={ScheduledStudiokwDetail}/>
                <Route path={'/scheduling_index'} component={SchedulingIndex} />
                <Route path={'/scheduling_index_list/:id?'} component={ScheduledStudioKwIndexDetail}/>
                <Route path={'/market-screener-listing'} component={VolumeRetrieveListing} />
                <Route path={'/create-market-screener'} component={CreateVolumeRetrieve} />
                <Route path={'/create-market-screener-form'} component={VolumeRetrieveForm} />
                <Route path={'/market-screener'} exact component={VolumeRetrieve} />
                <Route path={"/market-screener/edit/:id"} exact component={VolumeRetrieveEdit} />
                <Route path={'/duplicate-keywords-gpt'} component={DuplicateKeywordsGpt} />                
                <Route path={'/keyword-clustering'} component={KeywordClustering} />
                <Route path={'/keyword-clustering-file/:id?'} component={KeywordClusteringFile} />
                <Route path={'/llm-visibility'} component={LLMVisibilityListing} />
                <Route path={'/add-llm-visibility/:id?'} component={LLMVisibilityForm} />
                <Route path="/category-text-gen" exact component={CategoryTextGenListing} />
                <Route path="/add-category-text-gen" exact component={CategoryTextGenForm} />
                <Route path="/add-category-text-gen/:id" exact component={CategoryTextGenForm} />
                <Route path={'/ped-generator'} component={PED} />
                <Route path={'/content-gen'} component={ContentGen} />
                <Route path={'/content-gen-file/:id?'} component={ContentGenFile} />
                <Route path={'/ped-generator-file/:id?'} component={PEDFile} />
                <Route path={'/add-studiokw/:id?'} component={AddStudiokw} />
                <Route path={'/add-scheduling/:id?'} component={AddScheduling} />
                <Route path={'/add-scheduling-index/:id?'} component={AddSchedulingIndex} />
                <Route path={'/duplicate/:id?'} component={AddStudiokw} />
                <Route path={'/lazy-load'} component={LazyLoad} />
                <Route path={'/bigquery-exporter'} component={BigQueryExporter} />
                <Route path={'/bigquery-exporter-file/:id?'} component={BigQueryExporterFile} />
                <Route path={'/bulk-indexing'} component={BulkIndexing} />
                <Route path={'/semrush'} component={SemRush} />
                <Route path={'/html-cleaner'} component={HtmlCleaner} />
                <Route path={'/monitoring-dashboard'} component={MonitoringDashboard} />
                <Route path={'/seo-sentinel/site-urls/edit/:id'} exact component={SiteUrlManage} />
                <Route path={'/seo-sentinel/site-urls/edit'} exact component={SiteUrlManage} />
                <Route path={'/seo-sentinel/site-urls'} exact component={SiteUrlList} />
                <Route path={'/seo-sentinel/alert-events/:siteUrlId'} exact component={AlertEvents} />
                <Route path={'/seo-sentinel/alert-events/:siteUrlId/:dayDate'} exact component={AlertEventsDetail} />
                <Route path={'/seo-sentinel/email-alerts/:id?'} component={EmailAlertsRead} />
                <Route path={'/studiokw/email-alerts/:id?'} component={StudiokwEmailAlertsRead} />

                <Route path={'/reporting'} exact component={Listing} />
                <Route path={'/reporting-dimension-groups'} exact render={() => <DimensionGroups/>}/>
                <Route path={'/reporting-create'} component={CreateReport} />
                <Route path={"/reporting/reports/seo/:id"} exact component={SeoReport}/>
                <Route path={"/reporting/dimension-groups/info/:name"} exact component={DimensionGroupInfo} />
                <Route path={"/reporting/dimension-groups"} exact render={() => <DimensionGroups/>} />
                <Route path={"/reporting/saved-dimensions/:id"} exact component={DimensionDetail} />
                <Route path={"/reporting/custom-dimensions/:id"} exact component={DimensionDetail} />
                <Route path={"/reporting/custom-metrics/:id"} exact component={DimensionDetail}/>
                <Route path={'/keyword-intentions'} exact component={KeywordIntentions} />
                <Route path={'/add-keyword-intentions/:id?'} component={AddKeywordIntentions} />

                <Route
                  path="/"
                  exact
                  render={() =>
                    canAccessHome ? (
                      <Home />
                    ) : (
                      <Redirect to={defaultRoute} />
                    )
                  }
                />
              </Switch>
            </Container>
          </Router>
        </div>
        <div id="modal-portal" />
        <Footer />
      </div>
    )
  }
}

export default App
